import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import style from "./index.module.scss";
import "./animate.scss";

import Join from "./Join/index.js";
import Join2 from "./Join2/index.js";
import Exhibition from "./Exhibition/index.js";
import TierPerks from "./TierPerks/index.js";

import kv_mp4 from "@/assets/images/kv.mp4";

import { rootContext } from "@/context/rootContext";

function Home() {

  const navigate = useNavigate();
  const [bg1Active, setBg1Active] = useState(false);


  const [clientHeight, setClientHeight] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);
  const [pageTop, setPageTop] = useState(0);
  const [pageBottom, setPageBottom] = useState(0);
  const [main1State, setMain1State] = useState(false);
  const [main2State, setMain2State] = useState(false);

  const [kvOpacity, setKvOpacity] = useState(1);

  const { isLogin, setDialogIndex, creatorData, setTipContent, langState } = useContext(rootContext);

  const changeToBg1 = () => {
    setBg1Active(true);
  };

  const backToBg = () => {
    setBg1Active(false);
  };

  // 确认签约和游戏对应情况
  const checkSing = () => {
    const signPlatformList = creatorData.games.map(item => item.platform); // 已签署协议的平台
    const bingGameList = creatorData.realInfo.map(item => item.platform); // 账号已绑定的游戏所归属的平台
    for (const item of bingGameList) {
      if (signPlatformList.includes(item)) {
        // 至少一个绑定的游戏所归属的平台已经签署协议 可继续
        return true;
      }
    }
    return false;
  };

  const joinCreator = () => {
    if (isLogin && creatorData) {

      if (!creatorData.isCreator) { // 不是创作者 申请页
        navigate("/application");
        return;
      }

      if (creatorData.realInfo.length === 0 || !checkSing()) { // 是创作者 未签署协议/绑定的游戏都未签署协议 返回首页
        navigate("/");
        setTipContent(langState.signTip);
        setDialogIndex(3);
        return;
      }
    } else {
      setDialogIndex(1);
    }
  };

  const setPageIndex = () => {
    const scrollTop = window.document.documentElement.scrollTop;
    const pageHeight = document.documentElement.clientHeight;
    setScrollTop(scrollTop);
    setClientHeight(pageHeight);
    setPageTop(scrollTop + pageHeight * 0.25);
    setPageBottom(scrollTop + pageHeight * 0.75);
  };

  const main1ToMain2 = (state) => setMain1State(state);

  const main2ToMain3 = (state) => setMain2State(state);

  useEffect(() => {
    const scrollFun = setPageIndex;
    window.addEventListener("resize", scrollFun);
    window.addEventListener("scroll", scrollFun);
    scrollFun();

    return () => {
      window.removeEventListener("resize", scrollFun);
      window.removeEventListener("scroll", scrollFun);
    };
  }, []);

  useEffect(() => {
    const slide = clientHeight / 4;
    if (scrollTop > clientHeight - slide) {
      const opacity = (clientHeight - scrollTop) / slide;
      if (opacity >= 0 && opacity <= 1) {
        setKvOpacity((clientHeight - scrollTop) / slide);
      }
    } else {
      setKvOpacity(1);
    }
  }, [clientHeight, scrollTop]);



  return (
    <div>
      <div className={`${style.bg} ${bg1Active ? style.black : ""}`}>
        <section>
          <div className={`${style.kv}`} style={{opacity: kvOpacity}}>
            <video src={kv_mp4} autoPlay muted loop></video>
          </div>
        </section>
        <Join
          join={joinCreator}
          pageInfo={{clientHeight, scrollTop, pageTop, pageBottom}}
          endFun={(state) => { main1ToMain2(state); }}
          langState={langState}
          />
        <Exhibition
          changeToBg={changeToBg1}
          backToBg={backToBg}
          open={main1State}
          pageInfo={{clientHeight, scrollTop, pageTop, pageBottom}}
          endFun={(state) => { main2ToMain3(state); }}
          langState={langState}
          />
        <TierPerks
          activeBg={bg1Active}
          changeToBg={changeToBg1}
          backToBg={backToBg}
          open={main2State}
          langState={langState}
          />
        <Join2
          active={bg1Active}
          join={joinCreator}
          langState={langState}
          />
      </div>
    </div>
  );
}

export default Home;
